const canonical = require("../config/productionBrowserConfig.json");

function validateBrowserIdentity(actual) {
  for (const key of [
    "apiKey", "authDomain", "projectId", "storageBucket", "messagingSenderId",
    "appId", "measurementId", "appCheckProvider", "recaptchaSiteKey",
    "functionsRegion", "siteOrigin",
  ]) {
    if (!actual[key] || actual[key] !== canonical[key]) {
      throw new Error(
        `The production browser setting ${key} does not match the canonical production Web app.`,
      );
    }
  }
}

module.exports = {validateBrowserIdentity};
